// Vuex module for reactive unseen-inbox state.
// Replaces the module-scoped integer + CustomEvent bus in feedSeen.js for
// the nav dot and PWA badge. feedSeen.js localStorage writes are delegated
// to markFeedSeen() — not duplicated here.

import { setBadge, clearBadge } from "../../utils/appBadge";
import { markFeedSeen } from "../../utils/feedSeen";

export default {
  namespaced: true,

  state: () => ({
    unseenCount: 0,
  }),

  getters: {
    unseenCount: (state) => state.unseenCount,
    hasUnseen: (state) => state.unseenCount > 0,
  },

  mutations: {
    SET_UNSEEN_COUNT(state, n) {
      state.unseenCount = Math.max(0, n | 0);
    },
    INCREMENT_UNSEEN(state) {
      state.unseenCount += 1;
    },
    CLEAR_UNSEEN(state) {
      state.unseenCount = 0;
    },
  },

  actions: {
    markHasNew({ commit, getters }) {
      commit("INCREMENT_UNSEEN");
      setBadge(getters.unseenCount);
    },
    setCount({ commit }, n) {
      commit("SET_UNSEEN_COUNT", n);
      setBadge(n);
    },
    markSeen({ commit }, username) {
      commit("CLEAR_UNSEEN");
      clearBadge();
      markFeedSeen(username);
    },
  },
};
